import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  QueryList,
  TemplateRef,
  ContentChildren,
  AfterContentInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { AppTemplateDirective } from '@/app/shared/directives/app-template';

import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon';
import { IconButtonComponent } from '@/app/shared/components/ui/icon-button';
import { AppDialogRef, BaseDialogComponent } from '@/app/shared/components/ui/dialog';

import { Nullable } from '@/app/shared/types';

import { DialogTitleComponent } from '../dialog-title';

@Component({
  selector: 'app-dialog-header',
  imports: [IconButtonComponent, SvgIconComponent, DialogTitleComponent, NgTemplateOutlet],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-header',
  },
})
export class DialogHeaderComponent implements AfterContentInit {
  customHeaderTemplate: Nullable<TemplateRef<any>>;

  @ContentChildren(AppTemplateDirective)
  templates: Nullable<QueryList<AppTemplateDirective>>;

  constructor(private dialogRef: AppDialogRef<BaseDialogComponent<any, any>>) {}

  ngAfterContentInit() {
    (this.templates as QueryList<AppTemplateDirective>).forEach((item) => {
      switch (item.getType()) {
        case 'customTemplate':
          this.customHeaderTemplate = item.template;
          break;
      }
    });
  }

  closeDialog() {
    this.dialogRef.cancel();
  }
}
